var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 .5h21v21H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M17.719 9.688H15.75V6.406a4.594 4.594 0 0 0-4.594-4.593 4.62 4.62 0 0 0-4.594 4.593v3.282H4.595a1.97 1.97 0 0 0-1.969 1.968v7.875c0 1.088.881 1.969 1.969 1.969h13.125a1.97 1.97 0 0 0 1.968-1.969v-7.875a1.97 1.97 0 0 0-1.968-1.969M7.875 6.406a3.281 3.281 0 1 1 6.563 0v3.282H7.875zm10.5 13.125a.656.656 0 0 1-.656.657H4.594a.656.656 0 0 1-.657-.657v-7.875c0-.362.294-.656.657-.656h13.125c.362 0 .656.294.656.656zM10.5 13.625h1.313v3.938H10.5z",
    clipRule: "evenodd"
  })));
};
export default SvgLock;